import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
// import {ReCaptchaV3Service} from 'ng-recaptcha';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent extends BaseClass<any> implements OnInit {

  formData!: FormGroup;
  submitted = false;
  errors: any;
  data: any;
  key: any;

  constructor(public service: WebserviceService,
    private fb: FormBuilder,
    private actRoute: ActivatedRoute,
    public bsModalRef: BsModalRef,
    private router: Router,
    public _common: CommonService,
    private _message: MessageService
  ) {
    super(document);

  }

  ngOnInit(): void {
    this.formData = this.fb.group({
      market_id: ['', Validators.required],
      market_type_id: ['', Validators.required],
      min_bet: ['', Validators.required],
      max_bet: ['', Validators.required],
      max_profit: ['', Validators.required],
      max_market_profit: ['', Validators.required],
      bet_allow: ['', Validators.required],
    });
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  get f() {
    return this.formData.controls;
  }

  getData() {
    let uid = this.actRoute.snapshot.paramMap.get('uid') ? this.actRoute.snapshot.paramMap.get('uid') : this.userData?.id;
    this.getServices().Get(`${this.env.baseUrl + this.api.marketSettings}/${uid}/${this.key?.market_id}/${this.key?.market_type_id}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.data = res?.data?.data;
          this.formData.patchValue({
            'market_id': this.key?.market_id,
            'market_type_id': this.key?.market_type_id,
            'min_bet': res?.data?.data?.min_bet,
            'max_bet': res?.data?.data?.max_bet,
            'max_profit': res?.data?.data?.max_profit,
            'max_market_profit': res?.data?.data?.max_market_profit,
            'bet_allow': res?.data?.data?.bet_allow,
          })
        }
      });
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.formData.invalid) {
      return;
    }
    this.formData.patchValue({
      'bet_allow' : (this.formData.value.bet_allow == true || this.formData.value.bet_allow == 1) ? 1 : 0
    })
    let uid = this.actRoute.snapshot.paramMap.get('uid') ? this.actRoute.snapshot.paramMap.get('uid') : this.userData?.id;
    let req = this._common.JSON_to_formData(this.formData.value);
    this.isLoad = true;
    this.getServices().Post(`${this.env.baseUrl + this.api.marketSettings}/${uid}`, req).subscribe(
      (res) => {
        this.isLoad = false;
        if (res.status == true) {
          this._message.succmessage(res.data.message);
          this.bsModalRef.hide();
        } else {
          this.errors = res.data;
          this._message.errmessage(res.error.message);
        }
      },
      (err) => {
        console.log(err);
      });
  }

}
